export default __webpack_public_path__ + "static/media/a1-4-5.33d18414.jpg";